/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum OpMedicationType {
  PREOP = 'PREOP',

  INTRAOP_ANA = 'INTRAOP_ANA',

  INTRAOP_ANT = 'INTRAOP_ANT',

  INTRAOP_FLUID_CRY = 'INTRAOP_FLUID_CRY',

  INTRAOP_FLUID_COL = 'INTRAOP_FLUID_COL',

  POSTOP_ANA = 'POSTOP_ANA',

  POSTOP_ANT = 'POSTOP_ANT',

  POSTOP_FLUID_CRY = 'POSTOP_FLUID_CRY',

  POSTOP_FLUID_COL = 'POSTOP_FLUID_COL',
}
